import React from 'react';
import styles from '../styles.module.scss';
import cN from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/search/store';
import { I_departureTimesRange, I_FilterOption, I_FilterItemList } from '../interface';
import { displayRtow } from '@utils/formatDisplay';

import CheckboxItem from './CheckboxItem';
import TimeRangeItem from './TimeRangeItem';

interface I_TimeRangeBlockProps {
    title: string;
    cols: number;
    crossDayOptions: I_FilterOption[] | undefined;
    departureTimeRanges?: I_departureTimesRange[];
    mobileProps?: {
        tempMFilter: I_FilterItemList | null;
        setTempMFilter: Function;
    };
}

// 出發時間
const TimeRangeBlock = (props: I_TimeRangeBlockProps) => {
    const moduleName = 'filterBlock';
    const { title, crossDayOptions, departureTimeRanges, mobileProps } = props;
    const { UrlParams } = useSelector((state: RootState) => state.search);

    return (
        <li className={styles[moduleName]}>
            <div className={cN(styles.Block_title)}>
                <div className={cN(styles.Title)}>{title}</div>
            </div>
            <div className={cN(styles.Block_content, { show: true })}>
                <ul className={cN(styles.CheckBoxes)}>
                    {crossDayOptions?.map((option) => {
                        return (
                            <CheckboxItem
                                key={`${option.text}-${option.value}`}
                                filterType="crossday"
                                cols="col1"
                                text={option.text}
                                value={option.value}
                                isDisable={false}
                                {...mobileProps}
                            />
                        );
                    })}
                </ul>
                {departureTimeRanges &&
                    departureTimeRanges.length > 0 &&
                    departureTimeRanges.map((_, index) => (
                        <TimeRangeItem
                            key={index}
                            title={displayRtow(index + 1, UrlParams.Rtow)}
                            seqNo={index}
                            maxNum={departureTimeRanges.length}
                            timeRanges={departureTimeRanges[index]}
                            {...mobileProps}
                        />
                    ))}
            </div>
        </li>
    );
};

export default TimeRangeBlock;
